/* tslint:disable */

/**
 */
export class TypeAny {
}
